import * as React from 'react';
import { cn } from '../../../../utils/cn';

import "./filters.css";

type FiltersWrapperProps = {
    children: React.ReactNode;
    className?: string;
}

export const FiltersWrapper = ({
    children, className = ''
}: FiltersWrapperProps) => {
    return (
        <div className={cn('filters-wrapper', className)}>
            {children}
        </div>
    )
}